import { lazy } from "react";

const edit = lazy(() => import("./Edit").then(m => ({ default: m.ServiceProviderFirmEdit })));
const list = lazy(() => import("./List").then(m => ({ default: m.ServiceProviderFirmList })));
const create = lazy(() => import("./Create").then(m => ({ default: m.ServiceProviderFirmCreate })));

export default { edit, list, create };
